module.exports = __webpack_public_path__ + "img/bgw2.95c2e6d6.jpg";